import NewDesign from 'components/NewDesign';
import React from 'react';
import Props from '../../Components/Props';
import JSXCode from '../../Components/JSXCode';

const TabTypography = () => {
  return (
    <div className='component:TabTypography'>
      <div className='tw-flex tw-gap-2 tw-flex-col'>
        <NewDesign.Typography className='tw-text-5xl'>Typography tw-text-5xl</NewDesign.Typography>
        <NewDesign.Typography className='tw-text-4xl'>Typography tw-text-4xl</NewDesign.Typography>
        <NewDesign.Typography className='tw-text-3xl'>Typography tw-text-3xl</NewDesign.Typography>
        <NewDesign.Typography className='tw-text-2xl'>Typography tw-text-2xl</NewDesign.Typography>
        <NewDesign.Typography className='tw-text-xl'>Typography tw-text-xl</NewDesign.Typography>
        <NewDesign.Typography className='tw-text-lg'>Typography tw-text-lg</NewDesign.Typography>
        <NewDesign.Typography className='tw-text-base'>
          Typography tw-text-base
        </NewDesign.Typography>
        <NewDesign.Typography className='tw-text-sm'>Typography tw-text-sm</NewDesign.Typography>
        <NewDesign.Typography className='tw-text-xs'>Typography tw-text-xs</NewDesign.Typography>
        <NewDesign.Typography showMaxChar={100} className='tw-text-sm'>
          Long text and show see more / see less - simply dummy text of the printing and typesetting
          industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,
          when an unknown printer took a galley of type and scrambled it to make a type specimen
          book. It has survived not only five centuries, but also the leap into electronic
          typesetting, remaining essentially unchanged. It was popularised in the 1960s with the
          release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop
          publishing software like Aldus PageMaker including versions of Lorem Ipsum.
        </NewDesign.Typography>
        <NewDesign.Typography
          showMaxChar={100}
          options={{ truncateByTooltip: true }}
          className='tw-text-sm'
        >
          Long text and hover to see full - simply dummy text of the printing and typesetting
          industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s
        </NewDesign.Typography>
      </div>

      <div className='tw-mt-3'>
        <JSXCode
          code={`<NewDesign.Typography
        onClick={() => {}}
        className="tw-text-5xl"
        style={{}}
        component="span"
        showMaxChar={100}
>
        Some text here
</NewDesign.Typography>`}
        />
      </div>

      <Props
        className='tw-mt-5'
        source={[
          {
            prop: 'onClick',
            type: 'func',
            default: 'undefined',
          },
          {
            prop: 'style',
            type: 'object',
            default: 'undefined',
          },
          {
            prop: 'className',
            type: 'string',
            default: 'undefined',
          },
          {
            prop: 'component',
            type: `"i" | "span" | "p" | "label" | "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "a"`,
            default: 'span',
          },
          {
            prop: 'showMaxChar',
            type: 'number',
            default: 'undefined',
          },
          {
            prop: 'options',
            type: `{
              truncateByTooltip: boolean
            }`,
            default: 'undefined',
          },
        ]}
      />
    </div>
  );
};

export default TabTypography;
